import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { map, combineLatest, Subscription, distinctUntilChanged, Observable } from 'rxjs';
import { Logger, OrganizationService } from 'src/app/@shared';
import { EventAssetsService, OfferAsset, OfferAssetsService, ProductAssetsService } from 'src/app/modules/standard/v1';

const log = new Logger('OfferAssetsTableComponent');

@Component({
  selector: 'app-product-assets-table',
  templateUrl: './product-assets-table.component.html',
  styleUrls: ['./product-assets-table.component.scss']
})

export class ProductAssetsTableComponent implements OnInit {
  viewModel$ = combineLatest([
    this.productassetService.assets$,
    this.productassetService.isLoading$,
    this.productassetService.page$,
    this.productassetService.productId$,
    this.organizationService.assetsUrl$,
    this.productassetService.totalRecords$
  ]).pipe(
    map(([assets, isLoading, page, productId, assetsUrl, totalRecords]) => {
      if (assets.length == 0 && page.pageIndex > 0) {
        page.previousPageIndex = 0
        page.pageIndex = 0
        this.productassetService.page(page);
        this.productassetService.reload();
        }
      return { assets, isLoading, page, productId, assetsUrl, totalRecords }
    }),
  );


  assetsUrl$: Observable<string> = this.organizationService.assetsUrl$;
  flexMediaWatcher!: Subscription;
  displayedColumns = ['select','Image', 'AssetName', 'Type', 'FileName', 'ClientKey', 'Actions'];
  assetsList: OfferAsset[] = [];
  selection = new SelectionModel<OfferAsset>(true, []);

  constructor(private productassetService: ProductAssetsService<OfferAsset>,
    private route: ActivatedRoute,
    private router: Router,
    private mediaObserver: MediaObserver, private organizationService: OrganizationService) { }

  ngOnInit(): void {
    log.debug('init');

    this.productassetService.productId = this.route.snapshot.params['productId'];
    this.productassetService.reload();
    // detect changes in viewport size to handle show/hide of table columns
    const getAlias = (MediaChange: MediaChange[]) => {
      return MediaChange[0].mqAlias;
    };

    this.flexMediaWatcher = this.mediaObserver
      .asObservable()
      .pipe(
        distinctUntilChanged(
          (x: MediaChange[], y: MediaChange[]) => getAlias(x) === getAlias(y)
        ))
      .subscribe((change) => {
        if (change.some(x => x.mqAlias === 'xs')) {
          this.displayedColumns = ['select', 'AssetName'];
        }
        else {
          this.displayedColumns = ['select', 'Image', 'AssetName', 'Type', 'FileName', 'ClientKey', 'Actions'];
        }
      });

    this.productassetService.assets$.subscribe((data) => {
      this.assetsList = data;
    });
  }


  onSort(sortState: Sort): void {
    this.productassetService.sort(sortState);
    this.selection.clear();
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.productassetService.page(pageEvent);
  }

  onRowDoubleClick(id: string) {
    this.router.navigate([`${id}/details`], { relativeTo: this.route });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.assetsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.assetsList.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }
  public clearSelection() {
    this.selection.clear();
  }
  public getImageSrc(assetsUrl: any, assets: any) {
    let imagesrc = '';
    if (assets.Type === 'application/pdf') {
      imagesrc = './assets/images/pdf.png';
    } else if (assets.Type.indexOf('audio') > -1) {
      imagesrc = './assets/images/mp3.jpg';
    } else if (assets.Type.indexOf('video') > -1) {
      imagesrc = './assets/images/mp4.png';
    } else if (assets.Type.indexOf('text') > -1) {
      imagesrc = './assets/images/text.png';
    }
    else {
      imagesrc = assetsUrl + '/' + assets.Detail.FileName;
    }
    return imagesrc;
  }
}
